import React, { PureComponent } from 'react';
import { Badge } from 'react-bootstrap';

class UsuarioInfo extends PureComponent {

  renderRoles = (item) => {
    return <Badge key={ item.role } variant="info">{ item.description  }</Badge>
  }

  render() {
    const { data } = this.props;

    return (
      <>
        { data.email }
        <br/>

        <p>
          { !!data.roles && data.roles.map(this.renderRoles) }
        </p>
      </>
    );
  }
}

export default UsuarioInfo;